module.exports = __webpack_public_path__ + "static/link-preview-a4163c8bc280b2df631c2854f9295e24.png";